import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Checkbox, Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { sorter } from '../utils/sortHelpers';

// Recursive component that builds the given group and its subgroups and controls
function ControlGroup({ group, checkedControls, openControl, handleCheckChange, handleOpen }) {
  const groups = group.groups?.map((item) => ({ ...item, type: 'group' })) ?? [];
  const controls = group.controls?.map((item) => ({ ...item, type: 'control' })) ?? [];
  const allControls = [...groups, ...controls].sort(sorter);

  return (
    <div key={`${group.id}-div`}>
      <ListItem key={group.id}>
        <ListItemIcon>
          <Checkbox
            id={`${group.label} ${group.title}-checkbox`}
            checked={checkedControls[group.id].value}
            onChange={() => handleCheckChange(group.id)}
          />
        </ListItemIcon>
        <ListItemButton id={`${group.label} ${group.title}`} onClick={() => handleOpen(group.id)}>
          <ListItemText primary={`${group.label} ${group.title}`} />
          {openControl === group.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </ListItemButton>
      </ListItem>
      <Collapse in={openControl.startsWith(group.id)} timeout="auto" key={`${group.id}-collapse`}>
        <List dense key={`${group.id}-list`}>
          {allControls.map((control) => (
            control.type === 'group' ? (
              <ControlGroup
                group={control}
                checkedControls={checkedControls}
                openControl={openControl}
                handleCheckChange={handleCheckChange}
                handleOpen={handleOpen}
                key={`${control.id}-controlgroup`}
              />
            ) : (
              <ListItem key={control.id}>
                <ListItemIcon>
                  <Checkbox
                    id={`${control.label} ${control.title}-checkbox`}
                    checked={checkedControls[control.id].value}
                    onChange={() => handleCheckChange(control.id)}
                  />
                </ListItemIcon>
                <ListItemText primary={`${control.label} ${control.title}`} />
              </ListItem>
            )
          ))}
        </List>
      </Collapse>
    </div>
  );
}

export default ControlGroup;
